var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPGeneralPlantHeatGenOutdoor = function SvgPGeneralPlantHeatGenOutdoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 508.1,
    y: 104.1,
    width: 64,
    height: 40,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.1,
    y: 144.1,
    width: 8,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.1,
    y: 144.1,
    width: 8,
    height: 2,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 523.1,
    cy: 124.1,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M521,124.8c-2.2,1.4-3.7,3.8-3.7,6.5c0,0.2,0,0.3,0,0.5c0.1,0.8,0.5,1.4,1.2,1.7l0,0c1.3,0.6,2.7,1,4.2,1.1 c0.2,0,0.3-0.1,0.3-0.3c0-0.1,0-0.1,0-0.1l0,0c-0.6-1.1-1-2.4-1-3.7c0-1.5,0.5-2.9,1.3-4.2h-0.1 C522.1,126.3,521.3,125.7,521,124.8L521,124.8z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.2,126.3c0.6,2.6,2.4,4.7,5,5.5c0.2,0.1,0.3,0.1,0.4,0.1c0.8,0.2,1.5-0.1,2-0.6l0,0c1-1,1.8-2.2,2.3-3.6 c0-0.2,0-0.3-0.2-0.4h-0.1l0,0c-1.2,0.3-2.5,0.2-3.8-0.2c-1.5-0.5-2.7-1.3-3.6-2.5c0,0.1,0,0.1,0,0.1 C524.9,125.7,524.1,126.3,523.2,126.3L523.2,126.3z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.2,124.7c2.6,0.2,5.2-0.9,6.8-3.1c0.1-0.1,0.2-0.2,0.3-0.4c0.4-0.7,0.4-1.5,0-2.1l0,0 c-0.6-1.3-1.6-2.4-2.7-3.3c-0.1-0.1-0.3-0.1-0.4,0.1v0.1l0,0c-0.1,1.3-0.6,2.5-1.4,3.6c-0.9,1.2-2.1,2.1-3.5,2.6l0.1,0.1 C525.2,122.9,525.5,123.8,525.2,124.7L525.2,124.7z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.4,122.3c1-2.4,0.8-5.2-0.8-7.4c-0.1-0.1-0.2-0.2-0.3-0.4c-0.5-0.6-1.3-0.8-2-0.7l0,0 c-1.4,0.2-2.8,0.7-4,1.6c-0.1,0.1-0.2,0.3-0.1,0.4l0.1,0.1l0,0c1.2,0.5,2.2,1.3,3,2.4c0.9,1.2,1.3,2.7,1.4,4.1l0.1-0.1 C522.6,121.7,523.6,121.7,524.4,122.3L524.4,122.3z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.8,122.3c-2-1.7-4.7-2.4-7.3-1.5c-0.2,0.1-0.3,0.1-0.4,0.2c-0.7,0.3-1.2,1-1.3,1.7l0,0 c-0.2,1.4-0.2,2.8,0.3,4.3c0,0.2,0.2,0.2,0.4,0.2c0,0,0.1,0,0.1-0.1l0,0c0.8-0.9,1.9-1.7,3.2-2.1c1.5-0.5,2.9-0.5,4.3-0.1v-0.1 C520.7,123.9,521,122.9,521.8,122.3L521.8,122.3z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.1,
    cy: 124.1,
    r: 2.2,
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 544.1,
    y: 108.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.1,
    y: 114.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.1,
    y: 120.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.1,
    y: 126.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.1,
    y: 132.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.1,
    y: 138.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }))));
};
export default SvgPGeneralPlantHeatGenOutdoor;